import Page from "webPage/Page";
import {handleHubspotForm} from "util/hubspot";

Page.register("page-template-contacto", () => {
    handleHubspotForm($('.js-contact-form'));
});